import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { useUpdateBlogMutation } from "../../redux/services/blogService/blog.Services";

function EditBlog({ data }) {
  const dispatch = useDispatch();
  const [updateBlog, { isLoading }] = useUpdateBlogMutation();

  // FORM STATE
  const [formData, setFormData] = useState({
    id: "",
    category_id: "",
    title: "",
    subtitle: "",
    slug: "",
    sub_heading: "",
    location: "",
    date: "",
    description: "",
    meta_title: "",
    meta_keywords: "",
    meta_description: "",
    status: "active",
  });

  // FILES
  const [frontImage, setFrontImage] = useState(null);
  const [blogImage2, setBlogImage2] = useState(null);
  const [descriptionImages, setDescriptionImages] = useState([]);

  // INIT DATA (IMPORTANT)
  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id,
        category_id: data.category_id,
        title: data.title,
        subtitle: data.subtitle,
        slug: data.slug,
        sub_heading: data.sub_heading,
        location: data.location,
        date: data.date,
        description: data.description,
        meta_title: data.meta_title,
        meta_keywords: data.meta_keywords,
        meta_description: data.meta_description,
        status: data.status,
      });
    }
  }, [data]);

  // HANDLE INPUT
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // FILE HANDLERS
  const handleFrontImage = (e) => {
    setFrontImage(e.target.files[0]);
  };

  const handleBlogImage2 = (e) => {
    setBlogImage2(e.target.files[0]);
  };

  const handleDescImages = (e) => {
    setDescriptionImages(Array.from(e.target.files));
  };

  // UPDATE API CALL
  const handleUpdate = async () => {
    try {
      const fd = new FormData();

      // TEXT DATA
      Object.keys(formData).forEach((key) => {
        if (key !== "id") {
          fd.append(key, formData[key]);
        }
      });

      // IMAGES
      if (frontImage) {
        fd.append("front_blog_image", frontImage);
      }

      if (blogImage2) {
        fd.append("blog_image_2", blogImage2);
      }

      descriptionImages.forEach((img) => {
        fd.append("description_images", img);
      });

      const res = await updateBlog({
        id: formData.id,
        formData: fd,
      }).unwrap();

      console.log("UPDATED SUCCESS:", res);

      dispatch(closeModal());
    } catch (error) {
      console.log("UPDATE ERROR:", error);
    }
  };

  return (
    <>
      <div className="custom-modal-body">

        {/* IMAGE */}
        <div className="view-blog-image">
          <img src={data?.blogimage} alt={data?.title} />
        </div>

        {/* TITLE */}
        <input
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="form-control mb-2"
        />

        {/* CATEGORY */}
        <input
          name="category_id"
          value={formData.category_id}
          onChange={handleChange}
          className="form-control mb-2"
        />

        {/* STATUS */}
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="form-control mb-2"
        >
          <option value="active">Active</option>
          <option value="draft">Draft</option>
        </select>

        {/* IMAGES */}
        <input type="file" onChange={handleFrontImage} />
        <input type="file" onChange={handleBlogImage2} />
        <input type="file" multiple onChange={handleDescImages} />

      </div>

      {/* ACTION */}
      <div className="modal-btn-group">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleUpdate}
          disabled={isLoading}
        >
          {isLoading ? "Updating..." : "Save Changes"}
        </button>

      </div>
    </>
  );
}

export default EditBlog;